import React, {ComponentClass, FunctionComponent} from 'react';
import {render} from '@inlet/react-pixi';
import {Container} from 'pixi.js';
import {IBrowser} from '@gongxigames/framework/core/types';

export async function asyncRenderComponentToContainer<P extends {}>(
    browser: IBrowser,
    component: FunctionComponent<P> | ComponentClass<P> | string,
    props?: P | null,
    container: Container = new Container()
): Promise<Container> {
    return new Promise(res => {
        render(React.createElement(component, props), container, () => {
            browser.addTimeout(() => res(container));
        });
    });
}
